import { render, staticRenderFns } from "./ChannelsEditView.vue?vue&type=template&id=295ced31&"
import script from "./ChannelsEditView.vue?vue&type=script&lang=js&"
export * from "./ChannelsEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports